import { useErrorToast } from "components/toast/ToastComponet";
import {
  FindCardsTotalSallesFunction,
  FindTopCashTypesFunctions,
  FindTopSellesGraphicClientsFunction,
} from "functions/Vendas";
import type {
  FindClientsSallesCashParms,
  FindSallesCardsTotalTypes,
  FindTopClientsSallesParms,
  ResponseFindClientsSallesCashTypes,
  ResponseFindTopClientsSalles,
  TopSallesGraphicTypes,
} from "types/salles";

export function useSell() {
  const toast = useErrorToast();

  const findCardsTotalSalles = async (): Promise<FindSallesCardsTotalTypes> => {
    try {
      const resp: FindSallesCardsTotalTypes =
        await FindCardsTotalSallesFunction();
      return resp;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTopSellesGraphicClients = async (
    parms: FindTopClientsSallesParms
  ): Promise<TopSallesGraphicTypes> => {
    try {			
      const resp: ResponseFindTopClientsSalles[] =
        await FindTopSellesGraphicClientsFunction(parms);

      const graphicData: TopSallesGraphicTypes = {
        VENDAS: {
          NOMES: resp.map((item: any) => item.NOME),
          VALORES: resp.map((item: any) => item.VALOR_TOTAL),
        },
      };

      return graphicData;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTopSellesGraphicClientsTicketMedium = async (
    parms: FindTopClientsSallesParms
  ): Promise<TopSallesGraphicTypes> => {
    try {
      const resp: ResponseFindTopClientsSalles[] =
        await FindTopSellesGraphicClientsFunction(parms);

      const graphicData: TopSallesGraphicTypes = {
        VENDAS: {
          NOMES: resp.map((item: any) => item.NOME),
          VALORES: resp.map((item: any) => item.TICKET_MEDIO_TOTAL),
        },
      };

      return graphicData;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTopSellesGraphicClientsCashType = async (
    parms: FindTopClientsSallesParms
  ): Promise<TopSallesGraphicTypes> => {
    try {
      const resp: ResponseFindTopClientsSalles[] =
        await FindTopSellesGraphicClientsFunction(parms);

      const graphicData: TopSallesGraphicTypes = {
        VENDAS: {
          NOMES: resp.map((item: any) => item.NOME),
          VALORES: resp.map((item: any) => item.TICKET_MEDIO_TOTAL),
        },
      };

      return graphicData;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  const findTopSallesGraphic = async (
    parms: FindClientsSallesCashParms
  ): Promise<TopSallesGraphicTypes> => {
    try {
      const resp: ResponseFindClientsSallesCashTypes[] =
        await FindTopCashTypesFunctions(parms);

      const graphicData: TopSallesGraphicTypes = {
        VENDAS: {
          NOMES: resp.map((item: any) => item.NUMERARIO),
          VALORES: resp.map((item: any) => item.VALOR),
        },
      };

      return graphicData;
    } catch (error: any) {
      toast(error.response.data.error);
      throw error.response.data.error;
    }
  };

  return {
    findCardsTotalSalles,
    findTopSellesGraphicClients,
    findTopSellesGraphicClientsTicketMedium,
    findTopSellesGraphicClientsCashType,
    findTopSallesGraphic,
  };
}
